import functions from '../../../../../world/spa/libs/vuexFunctions';

export default {
    namespaced: true,
    state: {
        objs: []
    },
    getters: {
        ...functions.createDefaultGetters(['idWorldDocumentSeries']),
        getByWork: state => idWork => {
            return state.objs.filter(ds => ds.work == idWork);
        }
    },
    mutations: {
        ...functions.createDefaultMutations(['idWorldDocumentSeries'])
    },
    actions: {
        ...functions.createDefaultActionsWithStore(['idWorldDocumentSeries'])
    },
}